import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "pqr",
  ref: "pqrResults"
}
const _hoisted_2 = {
  class: "pqr-slider swiper js-product-query-results",
  ref: "pqrSwiperInstance"
}
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-slide pqr-slider__item" }
const _hoisted_5 = {
  class: "swiper-pagination pqr-slider__pagination",
  ref: "pagination"
}
const _hoisted_6 = {
  class: "swiper-button-prev pqr-slider__arrow-left",
  ref: "leftArrow"
}
const _hoisted_7 = {
  class: "swiper-button-next pqr-slider__arrow-right",
  ref: "rightArrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ProductCard, {
              portfolioType: product.portfolio,
              url: product.productDetailUrl,
              title: product.productDisplayName,
              imageUrl: product.primaryImageUrl,
              isFinishImageMissing: product.isFinishImageMissing,
              beautyImageUrl: product.beautyImageUrl,
              description: product.productBrowseDescription,
              numberOfFinishes: product.alternateFinishes.length,
              availability: product.availability,
              modelNumber: product.modelNumber,
              index: _ctx.index,
              product: product,
              translations: _ctx.translations,
              hasQuickship: product.quickShip,
              disableComparison: true,
              isDiscontinued: product.isDiscontinued,
              onComparisonItemRemoved: $options.removeComparisonItem
            }, null, 8 /* PROPS */, ["portfolioType", "url", "title", "imageUrl", "isFinishImageMissing", "beautyImageUrl", "description", "numberOfFinishes", "availability", "modelNumber", "index", "product", "translations", "hasQuickship", "isDiscontinued", "onComparisonItemRemoved"])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ], 512 /* NEED_PATCH */),
    _createCommentVNode(" If dots navigation type "),
    _withDirectives(_createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */), [
      [_vShow, this.moduleData.navigationType === 0]
    ]),
    _createCommentVNode(" If arrows navigation type "),
    _withDirectives(_createElementVNode("div", _hoisted_6, null, 512 /* NEED_PATCH */), [
      [_vShow, this.moduleData.navigationType === 1]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, null, 512 /* NEED_PATCH */), [
      [_vShow, this.moduleData.navigationType === 1]
    ])
  ], 512 /* NEED_PATCH */))
}